/**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */


const $el = $(el);

let lastScrollTop = $window.scrollTop();
let heightEl      = $el.outerHeight();

if (Is.mobile.ANY()) {
    heightEl = 20;
}

$window
.on('scroll', function () {
        const scrollTop = $window.scrollTop();

        if (scrollTop >= heightEl) {
            if (!$body.hasClass('tiny-menu')) {
                $body.addClass('tiny-menu');
            }
        } else {
            if ($body.hasClass('tiny-menu')) {
                $body.removeClass('tiny-menu');
            }
        }

        lastScrollTop = scrollTop;
    });
